'use strict';

import {isFieldEmpty, isValidEmail, displayErrors, isFieldSame, debounce} from './_helper';
import Loader from '../../../_modules/loader/loader';

let $loginEmail = $('#loginEmail'),
    $loginPwd = $('#loginPwd'),
    $registerEmail = $('#registerEmail'),
    $confirmedEmail = $('#confirmedEmail'),
    //input fields on main navigation dropdowns
    $loginEmailNav = $('#loginEmailNav'),
    $loginPwdNav = $('#loginPwdNav'),
    $registerEmailNav = $('#registerEmailNav'),
    $confirmedEmailNav = $('#confirmedEmailNav'),
    _isInvalid = [],
    dataParams = {},
    $loginToken = $("#LoginToken"),
    $regToken = $("#RegisterToken"),
    $recaptchaSiteKey = $("#ReCaptchaSiteKey");

let loader = new Loader();

let onLoginFormClick = function(e){
    
    _isInvalid = [];

    if (!isValidEmail($loginEmail.val()) || isFieldEmpty($loginEmail)) {
        $loginEmail
            .parent().addClass('incomplete')
            .find('.error').slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        _isInvalid.push(0);
    }

    if (isFieldEmpty($loginPwd)) {
        $loginPwd
            .parent().addClass('incomplete')
            .find('.error').slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        _isInvalid.push(0);
    }

    if ($loginPwd.val().length < 8) {
        $loginPwd
            .parent().addClass('incomplete')
            .find('.error').slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        _isInvalid.push(0);
    }

    if (_isInvalid.length > 0) {
        $("#js-login").prop("disabled", false);
        $(this).addClass('error');
        return false;
    } else {
        _isInvalid = [];
        $(this).removeClass('error');
    }

    $loginToken.val(e);
    $("#login-form").trigger("submit");
}
/**
 There are 4 forms on homepage: 2 login and 2 register forms.
 The ones displayed on the dropdown are not type=submit
 **/

// form with type=submit
// $('.js-login').on('click', function (e) { 
// });

let onRegisterFormClick = function(e){
    let $btn = $("#js-register");
    _isInvalid = [];

    if (!isValidEmail($registerEmail.val()) || isFieldEmpty($registerEmail)) {
        $registerEmail
            .parent().addClass('incomplete')
            .find('.error').slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        _isInvalid.push(0);
    }

    if (!isValidEmail($confirmedEmail.val()) || isFieldEmpty($confirmedEmail)) {
        $confirmedEmail
            .parent().addClass('incomplete')
            .find('.error').slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        _isInvalid.push(0);
    }

    if (!isFieldEmpty($registerEmail) && !isFieldEmpty($confirmedEmail)) {

        if (!isFieldSame($registerEmail, $confirmedEmail)) {
            $confirmedEmail
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }
    }

    if (_isInvalid.length > 0) {
        $btn.addClass('error');
        return false;
    } else {
        _isInvalid = [];
        $btn.removeClass('error');
    }

    $regToken.val(e);  
    $("#register-form").trigger("submit");        
}

// form with type=submit
// $('.js-register').on('click', function (e) {
    
// });


let onLoginNavClick = function(e){
    let $btn = $(".js-login--nav");
    _isInvalid = [];

    // Define where to display ajax errors
    let $errorContainer = $btn.parent().siblings('.server-errors__wrap');

    if (!isValidEmail($loginEmailNav.val()) || isFieldEmpty($loginEmailNav)) {
        $loginEmailNav
            .parent().addClass('incomplete')
            .find('.error').slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        _isInvalid.push(0);
    }

    if (isFieldEmpty($loginPwdNav)) {
        $loginPwdNav
            .parent().addClass('incomplete')
            .find('.error').slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        _isInvalid.push(0);
    }

    if ($loginPwdNav.val().length < 8) {
        $loginPwdNav
            .parent().addClass('incomplete')
            .find('.error').slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        _isInvalid.push(0);
    }

    if (_isInvalid.length > 0) {
        $("#js-login-nav").prop("disabled", false);
        $btn.addClass('error');
        return false;
    } else {
        _isInvalid = [];
        $btn.removeClass('error');
    }

    loader.fadeIn();
    
    dataParams = {
        "Email": $loginEmailNav.val(),
        "Password": $loginPwdNav.val(),
        "Token": e
    };

    // $.ajax({
    //     url: '/api/account/login',
    //     dataType: 'json',
    //     contentType: 'application/json; charset=utf-8',
    //     type: 'POST',
    //     data: JSON.stringify(dataParams),
    //     success: function (data) {
    //         loader.fadeOut();
    //         $errorContainer.slideUp({
    //             duration: 500,
    //             easing: 'easeInOutExpo',
    //             queue: false
    //         });
    //         window.location.href = data.href;
    //     },
    //     error: function (error) {
    //         loader.fadeOut();
    //         displayErrors(error, $errorContainer);
    //     }
    // });

    $("#login-form-dropdown").trigger("submit");        
    return true;
}

// form with type=button and ajax call
// $('.js-login--nav').on('click', function (e) {
    
// });

let onRegisterNavClick = function(e){
    let $btn = $(".js-register--nav");
    _isInvalid = [];

    // Define where to display ajax errors
    let $errorContainer = $btn.parent().siblings('.server-errors__wrap');

    if (!isValidEmail($registerEmailNav.val()) || isFieldEmpty($registerEmailNav)) {
        $registerEmailNav
            .parent().addClass('incomplete')
            .find('.error').slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        _isInvalid.push(0);
    }

    if (!isValidEmail($confirmedEmailNav.val()) || isFieldEmpty($confirmedEmailNav)) {
        $confirmedEmailNav
            .parent().addClass('incomplete')
            .find('.error').slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        _isInvalid.push(0);
    }

    if (!isFieldEmpty($registerEmailNav) && !isFieldEmpty($confirmedEmailNav)) {

        if (!isFieldSame($registerEmailNav, $confirmedEmailNav)) {
            $confirmedEmailNav
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }
    }

    if (_isInvalid.length > 0) {
        $btn.addClass('error');
        return false;
    } else {
        _isInvalid = [];

        $btn.removeClass('error');
    }

    dataParams = {
        "Email": $registerEmailNav.val(),
        "ConfirmEmail": $confirmedEmailNav.val(),
        "Token": e
    };

    $.ajax({
        url: '/api/account/register',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'POST',
        data: JSON.stringify(dataParams),
        success: function (data) {

            $errorContainer.slideUp({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            window.location.href = data.href;
        },
        error: function (error) {
            displayErrors(error, $errorContainer);
        }
    });

    return true;
}

// form with type=button and ajax call
// $('.js-register--nav').on('click', function (e) {
    
// });

let hookRecaptcha = function(elementId, fnCallback) {
    if($(`#${elementId}`).length == 0) {
        return;
    }
    $(`#${elementId}`).on("click", function(e){
        e.preventDefault();    
        $(`#${elementId}`).prop("disabled", true);
        if(typeof grecaptcha !== 'undefined' && grecaptcha.ready != null){
            grecaptcha.ready(function(){
                grecaptcha.execute($recaptchaSiteKey.val(), {action: 'login'}).then(function(token) {
                    fnCallback(token);
                });
            });
        } else {
            console.warn("Google captcha not found");
            fnCallback("");
        }
    });
}


$(function () {
    let $window = $(window);

    $window.on('resize', debounce(setHeroHeight, 250));

    function setHeroHeight(){
        let windowHeight = $window.height(),
            headerHeight = $('.header').height(),
            heroHeight = windowHeight - headerHeight,
            maxHeight = $('.hero-image').data("max-height") || 0;

        if(maxHeight != 0 && heroHeight > maxHeight) {
            heroHeight = maxHeight;
        }

        $('.hero-image').css('min-height', heroHeight);
    }

    setHeroHeight();
    
    hookRecaptcha("js-login", onLoginFormClick);
    hookRecaptcha("js-login-nav", onLoginNavClick);
    hookRecaptcha("js-register", onRegisterFormClick);
    hookRecaptcha("js-register-nav", onRegisterNavClick);

    let $MFADateTime = $("#MFADateTime");
    if($MFADateTime.length > 0){
        let $otpExpiry = $("#OtpExpiry");
        let mfaDate = new Date($MFADateTime.val());
        let otpId = window.setInterval(function () {
            // Perform your operations
            let currentTime = new Date();
            let diffMilliseconds = mfaDate.getTime() - currentTime.getTime();
            let seconds = diffMilliseconds / 1000;
            let minutes = seconds / 60;
            $otpExpiry.html(`Your OTP will expire in ${Math.floor(minutes)} minute(s) and ${Math.round(seconds % 60)} second(s)`);
            if (seconds < 1 && minutes < 1) {
                $("#validate-otp-form").hide();
                $otpExpiry.html('Your OTP has expired.');
                window.clearInterval(otpId);
            }
        }, 1000)
    }

    $("input[data-restrict-name=true]").on("change keyup", function(e) {
        let $txt = $(this);
        let txtVal = $txt.val();
        $txt.val(txtVal.replace(/"/g, ''));
    });
});



